interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-800">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 flex h-10 items-center gap-1.5 rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}